var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33355 10.1659H8.88911C8.65336 10.1659 8.42727 10.0723 8.26057 9.90556C8.09387 9.73886 8.00022 9.51277 8.00022 9.27702V7.0548C8.00022 6.93692 7.95339 6.82388 7.87004 6.74053C7.78669 6.65718 7.67365 6.61035 7.55577 6.61035H7.11133",
    fill: "#1429B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33355 10.1659H8.88911C8.65336 10.1659 8.42727 10.0723 8.26057 9.90556C8.09387 9.73886 8.00022 9.51277 8.00022 9.27702V7.0548C8.00022 6.93692 7.95339 6.82388 7.87004 6.74053C7.78669 6.65718 7.67365 6.61035 7.55577 6.61035H7.11133",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.77789 4.83312C7.71895 4.83312 7.66243 4.8097 7.62075 4.76803C7.57908 4.72635 7.55566 4.66983 7.55566 4.61089C7.55566 4.55196 7.57908 4.49543 7.62075 4.45376C7.66243 4.41208 7.71895 4.38867 7.77789 4.38867",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.77783 4.83312C7.83677 4.83312 7.89329 4.8097 7.93497 4.76803C7.97664 4.72635 8.00005 4.66983 8.00005 4.61089C8.00005 4.55196 7.97664 4.49543 7.93497 4.45376C7.89329 4.41208 7.83677 4.38867 7.77783 4.38867",
    stroke: "#1429B8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.00016 14.1663C11.6819 14.1663 14.6668 11.1815 14.6668 7.49967C14.6668 3.8179 11.6819 0.833008 8.00016 0.833008C4.31839 0.833008 1.3335 3.8179 1.3335 7.49967C1.3335 11.1815 4.31839 14.1663 8.00016 14.1663Z",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.afcdfcdfd3972527c4be550da0737dd0.svg";
export { ForwardRef as ReactComponent };